import type { LumpsumRebalanceCategory, LumpsumRebalanceUnderReviewRecommendation } from '../../../../api/rebalance.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { RebalanceUnderReviewFundCard } from '../cards/RebalanceUnderReviewFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type RebalanceUnderReviewBucketAccordionProps = {
  category: LumpsumRebalanceCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function RebalanceUnderReviewBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: RebalanceUnderReviewBucketAccordionProps) {
  const underReviewRecommendations = getCategoryBucketItems<LumpsumRebalanceUnderReviewRecommendation>(category?.underReviewRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.REBALANCE,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.underReviewRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.underReviewRecommendations]}
      count={underReviewRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumRebalance,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.underReviewRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {underReviewRecommendations.map((recommendation, recommendationIndex) => (
        <RebalanceUnderReviewFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < underReviewRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
